import { Button } from "antd";
import { ReactNode } from "react";
import Container from "../Container";

type TFeatureItem = {
  imageUrl: string;
  imagePosition: "left" | "right";
  title: string;
  children: ReactNode;
};

export default function FeatureItem({
  imageUrl,
  imagePosition,
  title,
  children,
}: TFeatureItem) {
  return (
    <div className="my-16 py-8">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            {imagePosition == "left" && (
              <img src={imageUrl} className="w-full" />
            )}
            {imagePosition == "right" && (
              <div>
                <FeatureTitle title={title} />
                <div className="my-4">{children}</div>
                <StartNowButton />
              </div>
            )}
          </div>
          <div>
            {imagePosition == "right" && (
              <img src={imageUrl} className="w-full" />
            )}
            {imagePosition == "left" && (
              <div>
                <FeatureTitle title={title} />
                <div className="my-4">{children}</div>
                <StartNowButton />
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}

const FeatureTitle = ({ title }: { title: string }) => {
  return <div className="text-textHeading text-[40px] font-bold">{title}</div>;
};

const StartNowButton = () => {
  return (
    <Button className="bg-[#001652] !text-white hover:border-inherit">
      Start now - it’s free
    </Button>
  );
};
